import { useEffect, useRef } from "react";
import { conditions } from "../conditions/conditions";
import { ConditionName } from "../../interfaces/enums";

const useKeyPress = (key:string, cb:any) => {

    const callbackRef = useRef(cb);

    useEffect(() => {
      callbackRef.current = cb;
    },[])

    useEffect(() => {
      const handleKeyPress = (event:any) => {
        if (event.code === key && !["INPUT", "TEXTAREA"].includes(event.target.nodeName) && !event.target.isContentEditable && !conditions(ConditionName.showTagsPopover) && !conditions(ConditionName.showPersonalMarkerPopover) && !conditions(ConditionName.showFeedbackPopover)) callbackRef.current(event);
      }

      document.addEventListener("keydown", handleKeyPress);

      return () => document.removeEventListener("keydown", handleKeyPress);

    }, [key])

}
export default useKeyPress;